<template>
  <div>
    <Front/>
  </div>
</template>
